import { inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import type { VersionReadyEvent } from '@angular/service-worker';
import { ConfirmationDialogService } from '../components/confirm-dialog/confirm-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  intervalSource = interval(1 * 60 * 1000);
  private updates: SwUpdate = inject(SwUpdate);
  private confirm: ConfirmationDialogService = inject(ConfirmationDialogService);

  constructor() {
    if (this.updates.isEnabled) {
      this.intervalSource.subscribe(() => this.updates.checkForUpdate()
        .then());
    }
  }

  public checkForUpdates(): void {
    this.updates.versionUpdates.pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      ).subscribe(() => this.promptUser());
  }

  private promptUser(): void {
    console.log('Nueva versión disponible. ¿Desea cargar la nueva versión?');
    this.confirm.confirm('Nueva versión disponible', '¿Desea cargar la nueva versión?', 'Aceptar', 'Cancelar', 'md')
      .then((confirmed: any) => {
        if (confirmed) {
          this.updates.activateUpdate()
            .then(() => window.location.reload())
            .catch(error => {
               console.error('Error en la actualización: ', error);
            });
        }
      });
  }
}
